<template>
  <div class="wrapper">
    <div class="navBar">
      <div class="navBox">邀请参考组数({{ total.examinationCount }})</div>
      <div class="navBox">应考人数({{ doneNum }})</div>
      <div class="navBox">已考人数({{ doneNum }})</div>
      <div class="navBox">缺考人数 ({{ noDoNum }})</div>
    </div>
    <div class="actBar">
      <div class="actBarLeft">
        <el-button
          size="small"
          type="primary"
          icon="el-icon-upload2"
          @click="exportLog"
          :disabled="questionChoosen.length == 0"
          >导出</el-button
        >
        <el-button class="btn yks-blue-default" icon="el-icon-pie-chart"
          >统计分析</el-button
        >
        <el-button class="btn yks-blue-default" icon="el-icon-printer"
          >打印</el-button
        >
        <el-button
          class="btn yks-red-default delete-btn"
          icon="el-icon-delete"
          @click="deleteRecordList"
          ghost
          :disabled="!questionChoosen.length > 0"
          >删除所选</el-button
        >
       成绩:
        <el-input
          class="scoreInput"
          size="small"
          clearable
          v-model="searchCondition.minScore"
          placeholder="最小成绩"
        ></el-input>
       —
        <el-input
          class="scoreInput"
          size="small"
          clearable
          v-model="searchCondition.maxScore"
          placeholder="最大成绩"
        ></el-input>
        <br>
          考试时间：<el-date-picker
            size="mini"
            v-model="applyTimeRange"
            type="datetimerange"
            :picker-options="pickerOptions"
            range-separator="至"
            start-placeholder="开始日期"
            end-placeholder="结束日期"
            align="right"
            value-format="yyyy-MM-dd HH:mm:ss"
        >
        </el-date-picker>

        分组: <el-select
          v-model="searchCondition.studentGroupId"
          placeholder="请选择"
          size="small"
          clearable
      >
        <el-option
            v-for="item in paperGroupList"
            :key="item.groupName"
            :label="item.groupName"
            :value="item.groupId"
        >
        </el-option>
      </el-select>
      </div>

      <div class="actBarRight">
        <el-input
          size="small"
          placeholder="请输入内容"
          clearable
          v-model="searchForm.searchValue"
          class="input-with-select"
        >
          <el-select
            v-model="searchForm.searchKey"
            style="width: 100px"
            slot="prepend"
            placeholder="请选择"
          >
            <el-option
              v-for="one in options"
              :key="one.key"
              :label="one.label"
              :value="one.key"
            ></el-option>
          </el-select>
          <el-button
            slot="append"
            icon="el-icon-search"
            @click="getExamRecord()"
          ></el-button>
        </el-input>
      </div>
    </div>

    <div class="testStatusBar text-center">
      <div
        :class="['testStatus', { active: searchCondition.status == 2 }]"
        @click="changeStatus(2)"
      >
        已考完
        <el-badge :value="doneNum" type="primary"> </el-badge>
      </div>
      <div
        :class="['testStatus', { active: searchCondition.status == 1 }]"
        @click="changeStatus(1)"
      >
        <span class="tab-title">未考完</span>
        <el-badge :value="doingNum" type="warning"></el-badge>
      </div>

      <div v-show="isShow1" class="testStatus">
        <span class="tab-title">缺考</span>
        <el-badge :value="noDoNum"></el-badge>
      </div>
      <div
        v-show="isShow2"
        :class="['testStatus', { active: searchCondition.status == 3 }]"
        @click="changeStatus(3)"
      >
        <span class="tab-title">缺考</span>
        <el-badge :value="noDoNum"></el-badge>
      </div>
    </div>

    <el-divider></el-divider>

    <!--分页 -->
    <el-row>
      <el-col :span="24">
        <div class="pagination">
          <el-pagination
            @size-change="handleSizeChange"
            @current-change="handleCurrentChange"
            :current-page.sync="paginations.page_index"
            :page-sizes="paginations.page_sizes"
            :page-size.sync="paginations.page_size"
            :layout="paginations.layout"
            :total="paginations.total"
          >
          </el-pagination>
        </div>
      </el-col>
    </el-row>

    <div class="tableContainer">
      <Table
        :columns="columns1"
        :data="recordList"
        height="560"
        @on-selection-change="choosenChange"
        border
      >
        <template slot-scope="{ row, index }" slot="action">
          <div style="display: flex; justify-content: space-evenly">
            <el-tooltip class="item" effect="dark" placement="left-start">
              <div slot="content">
                {{ row.ipAddress }}<br />{{ row.browserInfo }}
              </div>
              <span class="el-icon-info"></span>
            </el-tooltip>

            <el-tooltip
              class="item"
              effect="dark"
              content="批卷"
              placement="top"
            >
              <div
                v-show="row.markExam"
                class="el-icon-document"
                @click="goToDetail('recordEdit', row)"
              ></div>
            </el-tooltip>
            <el-tooltip class="item" effect="dark" content="查看详情">
              <div class="el-icon-s-operation" @click="showDetail(row)"></div>
            </el-tooltip>
            <el-tooltip class="item" effect="dark" content="考试报告">
              <div
                class="el-icon-s-data"
                @click="goToDetail('recordReports', row)"
              ></div>
            </el-tooltip>
          </div> </template
      ></Table>
    </div>
    <el-dialog
      :visible.sync="recordDetail.ifShow"
      width="50%"
      style="padding: 0"
      append-to-body
    >
      <exam-result
        :submitData="recordDetail.data"
        :userData="recordDetail.item"
      ></exam-result>

      <span slot="footer" class="dialog-footer">
        <el-button @click="recordDetail.ifShow = false">取 消</el-button>
        <el-button type="primary" @click="recordDetail.ifShow = false"
          >确 定</el-button
        >
      </span>
    </el-dialog>
  </div>
</template>
       

<script>
import {
  examRecordSearch,
  deleteRecordList,
  exportExamRecord,
  getExamRecordDetail,
} from "@/api/examination/examination.js";
import examResult from "@/views/examination-management/component/examResult.vue";
export default {
  data() {
    return {
      paperGroupList:[],
      isShow1: false,
      isShow2: true,
      searchForm: {
        searchKey: "name",
        searchValue: "",
      },
      options: [
        {
          key: "name",
          label: "姓名",
        },
        {
          key: "phoneNumber",
          label: "电话",
        },
        {
          key: "idCardNo",
          label: "身份证",
        },
      ],
      total: {
        examinationCount: 1,
        testCount: 18,
        classification: 3,
        archive: 15,
      },
      paginations: {
        page_index: 1, //当前页
        page_size: 30, //每页多少条
        total: 100,
        page_sizes: [10, 15, 30, 50],
        layout: "sizes, prev, pager, next,jumper",
      },
      split: 0.2,
      searchCondition: {
        pageSize: 30,
        jumpPage: 1,
        accountId: 1,
        examId: 0,
        status: 2,
        name: "",
        phoneNumber: "",
        idCardNo: "",
        minScore: "",
        maxScore: "",
        startTime: "",
        endTime: "",
        studentGroupId:"",
      },
      columns1: [
        {
          type: "selection",
          width: 60,
          align: "center",
          key: "choose",
        },
        {
          title: "序号",
          type: "index",
        },

        {
          title: "分组",
          key: "groupName",
        },
        // {
        //   title: "组",
        //   key: "labelName",
        // },
        {
          title: "姓名",
          key: "name",
        },
        {
          title: "性别",
          key: "sex",
        },
        {
          title: "手机",
          key: "phoneNumber",
        },
        {
          title: "得分",
          key: "score",
        },
        {
          title: "得分比",
          key: "scoreRatio",
        },
        {
          title: "考试时间",
          key: "startTime",
        },
        {
          title: "用时",
          key: "timeCost",
        },

        {
          title: "操作",
          slot: "action",
          width: 130,
          align: "center",
        },
      ],
      recordList: [],
      noDoNum: 0,
      doingNum: 0,
      doneNum: 0,
      questionChoosen: [],
      recordDetail: { ifShow: false, data: "" },
      pickerOptions: {
        shortcuts: [
          {
            text: "最近一周",
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 7);
              picker.$emit("pick", [start, end]);
            },
          },
          {
            text: "最近一个月",
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 30);
              picker.$emit("pick", [start, end]);
            },
          },
          {
            text: "最近三个月",
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 90);
              picker.$emit("pick", [start, end]);
            },
          },
        ],
      },
      applyTimeRange: [],
    };
  },
  components: { examResult },
  created() {},
  mounted() {
    this.searchCondition.examId = this.$route.query.id;
    this.getExamRecord();
  },
  watch: {
    "searchForm.searchKey": function (newVal, oldVal) {
      this.searchForm.searchValue = "";
    },
    "searchCondition.minScore": function (newVal, oldVal) {
      if (newVal === "") {
        this.searchCondition.maxScore = "";
      }
    },
    "searchCondition.maxScore": function (newVal, oldVal) {
      if (newVal === "") {
        this.searchCondition.minScore = "";
      }
    },
    applyTimeRange(val) {
      console.log("时间变了", val);
      [this.searchCondition.startTime, this.searchCondition.endTime] = val;
    },
  },



  computed: {},
  methods: {
    showDetail(item) {
      getExamRecordDetail({ recordId: item.id }).then((data) => {
        this.recordDetail.data = data;
        this.recordDetail.item = item;
        this.recordDetail.ifShow = true;
        console.log(data, item);
      });
    },
    exportLog() {
      let link = document.createElement("a");
      link.href = `/api/file/download/exam-record?recordIds=${this.questionChoosen
        .map((item) => item.id)
        .join(",")}`;
      document.body.appendChild(link);
      link.click();
    },
    choosenChange(selection) {
      this.questionChoosen = selection;
    },
    goTo(url) {
      this.$router.push({ name: url });
    },
    goToDetail(routerName, item) {
      this.$router.push({ name: routerName, query: { id: item.id } });
    },
    handleSizeChange(page_size) {
      console.log(`每页 ${page_size} 条`);
      this.paginations.page_size = page_size;
      this.searchCondition.pageSize = page_size;
      this.getExamRecord();
    },
    handleCurrentChange(page) {
      console.log(`当前页: ${page}`);
      this.paginations.page_index = page;
      this.searchCondition.jumpPage = page;
      this.getExamRecord();
    },

    getExamRecord() {
      for (let i = 0; i < this.options.length; i++) {
        this.searchCondition[this.options[i].key] = "";
      }
      if (this.searchForm.searchKey) {
        this.searchCondition[
          this.searchForm.searchKey
        ] = this.searchForm.searchValue;
      }
      examRecordSearch(this.searchCondition).then((data) => {
        console.log("查询结果", data);
        this.paperGroupList =data.userGroupDTOList;
        this.name = data.name;
        this.doingNum = data.doingNum;
        this.noDoNum = data.noDoNum;
        this.doneNum = data.doneNum;
        this.recordList = data.recordDTOList || [];
        let totalList = [null, data.noDoNum, data.doneNum, data.doingNum];
        this.paginations.total = totalList[this.searchCondition.status];
        if (this.noDoNum == 0) {
          this.isShow1 = true;
          this.isShow2 = false;
        }
      });
    },
    changeStatus(status) {
      if (status == this.searchCondition.status) {
        return;
      }

      Object.assign(this.searchCondition, { status: status, jumpPage: 1 });
      this.getExamRecord();
    },

    deleteRecordList() {
      this.$Modal.confirm({
        title: "删除试题",
        content:
          "<p>您确定要删除开始记录吗？删除后会影响考试记录，请您谨慎操作</p>",
        onOk: () => {
          let deleteList = this.questionChoosen.reduce((total, item) => {
            total.push(item.id);
            return total;
          }, []);
          deleteRecordList({ ids: deleteList }).then(
            (data) => {
              this.$Message.success("删除成功");
              this.getExamRecord();
            },
            (data) => {
              this.$Message.error("删除失败");
            }
          );
        },
        onCancel: () => {
          this.$Message.info("Clicked cancel");
        },
      });
    },
  },
};
</script>

<style scoped lang="less">
.wrapper {
  background: #fff;
  font-size: 12px;
  margin: 15px;
  .navBar {
    display: flex;
    padding: 15px;
    justify-content: space-between;
    .navBox {
      display: flex;
      font-size: 1.5rem;
      border-radius: 10px;
      height: 95px;
      width: 22%;
      color: #fff;
      align-items: center;
      justify-content: center;
      i {
        font-size: 2rem;
      }
    }
    .navBox:nth-child(1) {
      background: #63b5ef;
    }
    .navBox:nth-child(2) {
      background: #92cb7b;
    }
    .navBox:nth-child(3) {
      background: #efd07c;
    }
    .navBox:nth-child(4) {
      background: #ec8472;
    }
  }
  .actBar {
    display: flex;
    justify-content: space-between;
    .actBarLeft {
      flex: 1;
      button {
        margin: 3px 5px 2px 0;
      }
    }

    .actBarRight {
      display: flex;
      width: 300px;
      line-height: 38px;
      .searchInput {
        // width: ;
      }
    }
  }

  .item {
    // margin-top: 10px;
    // margin-right: 40px;
    cursor: pointer;
  }

  .testStatusBar {
    display: flex;
    justify-content: center;

    .testStatus {
      padding: 3px 8px;
      line-height: 20px;
      margin-left: -1px;
      min-width: 50px;
      cursor: pointer;
    }

    .active {
      color: #618afd;
      z-index: 1;
    }
  }
  .text-center {
    text-align: center;
  }

  .label-unpassed {
    background-color: #ed6b75;
    padding: 2px 5px;
  }

  .yks-red-default.btn {
    color: #ec5953;
    border: 1px solid #ec5953;
    padding: 7px 20px;
    border-radius: 4px !important;
  }

  .yks-blue-default.btn {
    color: #36aafd;
    border: 1px solid #36aafd;
    padding: 7px 20px;
    border-radius: 4px !important;
  }

  .el-icon-document {
    cursor: pointer;
  }
  .scoreInput {
    display: inline-block;
    width: 100px;
    margin-right: 4px;
  }
}
/deep/ .el-dialog__body {
  padding: 0 20px;
}
</style>
